// Wires the host's concrete dependencies (Redux store, WebSocket dispatchers,
// UI toast, sign-in URL generator) into the shared @p81-common/shell-core-js
// package, then re-exports the resulting surface so the ~300 host call sites
// that import from "tools/apiConfigurator" keep working unchanged.
//
// Deferred wiring: the DI is applied inside `init()` rather than at module
// load. `tools/ws.js` has a circular read of `cookieEnabled` from this
// module, and doing any synchronous work here at import time creates a TDZ.
// Wiring on `init()` is called by App.tsx BEFORE any API call, so it's safe.

import {
  configureApiDeps,
  init as packageInit,
  initAuthorized as packageInitAuthorized,
} from "@p81-common/shell-core-js";
import store from "store/store";
import {
  initWSConnection,
  authWSConnection,
  setWSAccessToken,
  closeWSConnection,
} from "./ws";
import { showErrorMessage } from "./apiErrorsHelper";
import { signInUrl } from "routes/urlGenerators";

function wireApiDeps() {
  configureApiDeps({
    store,
    ws: { initWSConnection, authWSConnection, setWSAccessToken, closeWSConnection },
    errorHandler: { showErrorMessage },
    signInUrl,
  });
}

function init() {
  wireApiDeps();
  packageInit();
}

function initAuthorized() {
  packageInitAuthorized();
}

export * from "@p81-common/shell-core-js";
export { init, initAuthorized };
export default { init, initAuthorized };